import { aiEditor } from '@interaktiv/volto-ai-editor/config/AiEditorRegistry';
import AssistantExtras from '@interaktiv/volto-ai-editor/components/Assistant/AssistantExtras';
import assistant, {
  initialState,
} from '@interaktiv/volto-ai-editor/reducers/assistant';
import { LinoMockClient } from './LinoMockClient';
import { LinoAgentClient } from './LinoAgentClient';
import LinoManagement from './Management';
import linoSVG from '@plone/volto/icons/settings.svg';

declare const __SERVER__: boolean;

export default function installLino(config) {
  config.settings.controlpanels = [
    ...config.settings.controlpanels,
    { '@id': '/lino', group: 'Add-on Configuration', title: 'Lino' },
  ];
  config.settings.controlPanelsIcons.lino = linoSVG;
  config.addonRoutes = [
    ...(config.addonRoutes || []),
    { path: '/controlpanel/lino', exact: true, component: LinoManagement },
  ];
  const mock = config.settings.aiEditor.client === 'mock';
  aiEditor(config).useClient(
    mock ? new LinoMockClient() : new LinoAgentClient(),
  );
  config.addonReducers.assistant = (state, action) =>
    assistant(state ?? { ...initialState, permission: 'write' }, action);
  // Keep the integration in the editor sidebar.
  config.settings.appExtras = config.settings.appExtras.filter(
    ({ component }) => component !== AssistantExtras,
  );
  config.settings.expressMiddleware = (
    config.settings.expressMiddleware || []
  ).filter((middleware) => middleware.id !== 'ai-agent');
  if (__SERVER__ && !mock) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { default: linoMiddleware } = require('./siteReads');
    config.settings.expressMiddleware.push(linoMiddleware());
  }
}
